import { COLORS } from '@avalara/bat-apps-shared/constants';
import { t } from '@avalara/bat-apps-shared/i18n';
import styled from 'styled-components';

import ExternalLink from '../external-link';

const CtaWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 45px;
`;

const SalesCall = styled.div`
  background-color: ${COLORS.lightestGray};
  height: 170px;
  width: 450px;
  text-align: center;

  p {
    color: ${COLORS.grayBlack};
  }

  p, a {
    padding-top: 30px;
    font-size: 18px;
  }

  a.button {
    border-radius: 35px;
    font-size: 22px;
    margin-top: 30px;
    padding: 30px;
    color: ${COLORS.white};
    background-color: ${COLORS.lightBlue};
  }
`;

const ContactSales = () => (
  <CtaWrapper>
    <SalesCall>
      <p>
        Talk to Sales now&nbsp;&nbsp;<a href='tel://1-877-224-3650'>1-877-224-3650</a>
      </p>
      <ExternalLink className='button' href={`https://www.avalara.com/us/en/get-started.html${window.location.search}`}>
        {t('client.general.schedule-a-call')}
      </ExternalLink>
    </SalesCall>
  </CtaWrapper>
);

export default ContactSales;
